function getShopifyCart() {
  return new Promise(function(resolve, reject) {
    jQuery.get('/cart.js', function(cart) {
      if (cart) {
        resolve(cart);
      } else {
        reject("Failed to retrieve the cart.");
      }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
      reject(errorThrown);
    });
  });
}

  function clearShopifyCart() {
  //Shopify cart clear URL
  const clearCartUrl = 'https://fhfpartners.com/cart/clear.js';

  // Send a POST request to clear the cart
  fetch(clearCartUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(response => {
    if (response.ok) {
      // Cart cleared successfully
      console.log("Cart cleared.");
      location.reload();
    } else {
      // Error occurred
      console.error("Error clearing the cart.");
    }
  })
  .catch(error => {
    console.error("An error occurred while clearing the cart:", error);
  });
}

  // Function to format cart items for update
function formatItemsForUpdate(items) {
  const updates = {};
  items.forEach(item => {
    updates[item.id] = item.quantity;
  });
  return updates;
}

function filterItems(cart, available_points) {
  let sum = 0;
  const itemsToRemove = [];
  const items = cart.items.sort((a, b) => {
  const pointsA = parseInt(a.properties._swell_points_used) || 0;
  const pointsB = parseInt(b.properties._swell_points_used) || 0;
  return pointsA - pointsB;
});

  items.filter((item) => {
    if(item.quantity == 0){
      itemsToRemove.push(item);
        return false;
    }
    if (item.properties._swell_points_used) {
      sum = sum + (parseInt(item.properties._swell_points_used) * item.quantity);
      if (sum >= available_points && available_points < 0) {
        item.quantity = 0;
        itemsToRemove.push(item);
        return false;
      }
      if(item.quantity > 1){
        item.quantity = 0;
        itemsToRemove.push(item);
        return false;
      }
    }
    return true;
  });
  return itemsToRemove;
}

function updateCart(itemsToRemove) {
  jQuery.post('/cart/update.js', { updates: formatItemsForUpdate(itemsToRemove) })
    .done(function(updatedCart) {
      location.reload();
    })
    .fail(function(error) {
      console.error("Failed to update cart:", error);
    });
}

function adjustItemQuantitiesAndSyncCart(cart, available_points) {
  if (cart && Array.isArray(cart.items)) {
    const itemsToRemove = filterItems(cart, available_points);
    updateCart(itemsToRemove);
  }
}

function filterFaultyFreeProducts(cart){
  const items = cart.items;

  return items.filter(item => {
    
  if(Object.keys(item.properties).length === 0 && item.price === 0 && item.product_type !== "Display Materials"){
    item.quantity = 0;
    return true;
  } 
    return false
  });
}

function removeFaultyFreeProducts(cart) {
  const items = filterFaultyFreeProducts(cart);
  if (items.length > 0) {
  updateCart(items);
  }
}